module.exports = __webpack_public_path__ + "img/invite-not-pass.56b3ef4d.png";